export default "__VITE_ASSET__B1bAbA_K__"